<script setup lang="ts">
export interface DividerProps {
  color?: "light" | "dark";
}

const { color = "light" } = defineProps<DividerProps>();

const dividerClassName = {
  color: {
    light: "border-base-03",
    dark: "border-disabled-01",
  },
};
</script>

<template>
  <hr
    class="w-full border-t"
    :class="dividerClassName.color[color]"
    role="separator"
    data-testid="clr-divider"
  />
</template>
